// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.46.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#survey-page-heading[data-v-5ebaae16]{margin-bottom:20px}.survey-form[data-v-5ebaae16]{width:100%}.radio-question[data-v-5ebaae16]{color:#000;font-size:1rem}.italicize[data-v-5ebaae16]{font-style:italic}.radio-validation-message[data-v-5ebaae16]{color:red;padding-top:10px;font-size:.8rem}", ""]);
// Exports
module.exports = exports;
